import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getRecords } from "../../services/api.service.js";
import "react-toastify/dist/ReactToastify.css";
import { createPageData, basicFormData } from "./TechnicianInventoryFile.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../Style/loaderOverly.js";
import { AvForm } from "availity-reactstrap-validation";
import { LoaderCreatePage } from "../Loader/Loader.js";
import formatDateTime from "../../custom/Utils/formatDateTime.js";

const TechnicianInventoryView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, headerName, getEndpoint } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [fetchedData, setFetchedData] = useState(null);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (id) => {
    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: [
          { model: "user_masters", as: "createdBy" },
          { model: "user_masters", as: "technician" },
          { model: "material_masters", as: "material" },
        ],
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>{headerName} Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Engineer Name: </strong>
                                {formData?.inputData?.technician?.first_name ||
                                  "-"}{" "}
                                {formData?.inputData?.technician?.last_name ||
                                  "-"}
                              </p>
                              <p>
                                <strong>GMDS Code: </strong>
                                {formData?.inputData?.material?.gmds_code ||
                                  formData?.inputData?.material?.name ||
                                  "-"}
                              </p>
                              <p>
                                <strong>Quantity: </strong>
                                {formData?.inputData?.quantity || "-"}
                              </p>
                            </Col>

                            {/* Second Section (Right Side) */}
                            <Col md="6" className="p-3">
                              <p>
                                <strong>Assigned By: </strong>
                                {formData?.inputData?.createdBy?.full_name ||
                                  "-"}
                              </p>
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active === true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                              <p>
                                <strong>Created At: </strong>
                                {!formData?.inputData?.createdAt || loadingData
                                  ? "-"
                                  : formatDateTime(
                                      formData?.inputData?.createdAt,
                                    )}
                              </p>

                              {/* <p>
                                <strong>Updated At: </strong>
                                {!formData?.inputData?.updatedAt || loadingData
                                  ? "-"
                                  : formatDateTime(
                                      formData?.inputData?.updatedAt
                                    )}
                              </p> */}
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </AvForm>

                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TechnicianInventoryView;
